<template>
  <div>
    <el-form ref="form" :model="form" label-width="80px">
      <span>当前登陆人:{{this.logInfo.EmpName}}</span> <br>
      <span>工号: {{this.logInfo.EmpNo}}</span> <br>
      <span>部门: {{this.logInfo.DeptName}}</span> <br>
      <span>职位: {{this.logInfo.PositionName}}</span>
      <el-form-item label="模拟工号">
        <el-input v-model="form.EmpNo"></el-input>
      </el-form-item>

      <el-form-item>
        <el-button type="primary" @click="onSubmit">修改</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import Vue from "vue";
export default {
name: "TestLoginInfoChange",
  created() {
    this.logInfo = this.getLoginUserInfo();
  },
  data() {
    return {
      form:{
        EmpNo:''
      },
      logInfo: null
    }
  },
  methods: {
    checkEmpNo(EmpNo){
      var pattern = /^(?=HB|hb|SC|sc)^[a-zA-Z]{2}\d{8}$/
      return pattern.test(EmpNo);
    },
    onSubmit() {
      let isTrue = this.checkEmpNo(this.form.EmpNo);
      if (!isTrue){
        this.Message({
          message: '请检查格式',
          type: 'error',
          duration: 1000
        });
        this.form.EmpNo = ''
        return;
      }
      Vue.prototype.$http({
        url: Vue.prototype.$httpUrl.getuserinfo + "?code=" + this.form.EmpNo,
        method: "get",
      }).then(res => {
        if (res.data == null || res.data == '' ||res.data.Body.EmployeeInfo == null ||res.data.Body.EmployeeInfo.EmpNo == null || res.data.Body.EmployeeInfo.EmpNo == '') {
          location.href =
              "https://cdsso.centaline.com.cn/sso/sso-oauth/authorize?clienttype=qy&appid=be460f78-9d38-4644-ae7e-817185819291&redirect_uri=" +
              encodeURIComponent(window.location.href);
          return;
        }
        setCookie("logInfo", JSON.stringify(res.data.Body.EmployeeInfo), 7200);
        localStorage.setItem('logInfo', JSON.stringify(res.data.Body.EmployeeInfo));
        this.$store.state.login = true;
        this.logInfo = res.data.Body.EmployeeInfo;
        this.form.EmpNo = ''
        this.Message({
          message: '修改成功',
          type: 'success',
          duration: 1000
        });
      }, err => {
        console.log(err)
      });
    },

  }
}
function setCookie(key, value, t) {
  var oDate = new Date();
  oDate.setDate(oDate.getDate() + t);
  document.cookie = key + "=" + value + "; expires=" + oDate.toDateString();
}
</script>

<style scoped>
  span{
    font-size: 18px;
    margin-left: 50px;
  }
</style>